module.exports = __webpack_public_path__ + "static/media/firebase.b71c8998.png";